import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import AesMixin from './v2/AesMixin';
let RouterParamsAppMixin = class RouterParamsAppMixin extends Mixins(AesMixin) {
    get appUUID() {
        const route = this.$route.params;
        return route.appUUID || '';
    }
    get baseAppUUID() {
        const route = this.$route.params;
        return this.decrypt(route.appUUID || '');
    }
    get componentUUID() {
        return this.$route.params.componentUUID || '';
    }
    /**
     * Service Bundle Key from Router Parameters
     * @author Peter John Alvarado <peterjohn@gorated.ph>
     * @since Version {0.21.0}
     */
    get bundleKey() {
        const { key } = this.$route.params;
        return key || '';
    }
    get resellerUuid() {
        const route = this.$route.params;
        return route.resellerUuid || '';
    }
};
RouterParamsAppMixin = __decorate([
    Component
], RouterParamsAppMixin);
export default RouterParamsAppMixin;
